import React from 'react';
import PropTypes from 'prop-types';

import { ExternalLinkProvider } from '../../context/ExternalLink';

import HeaderContainerComponent from './HeaderContainer';

export { LIGHT_THEME, DARK_THEME, GREEN_THEME } from './shapes/theme.shape';

const HeaderContainer = ({ locales, localeToggle, ...restProps }) => (
  <ExternalLinkProvider
    currentLocale={locales.current}
    localeToggle={localeToggle}
  >
    <HeaderContainerComponent locales={locales} {...restProps} />
  </ExternalLinkProvider>
);

HeaderContainer.propTypes = {
  locales: PropTypes.shape({
    current: PropTypes.string
  }).isRequired,
  localeToggle: PropTypes.shape({
    chinese: PropTypes.bool
  })
};

HeaderContainer.defaultProps = {
  localeToggle: {}
};

export default HeaderContainer;
